<template>
  <div id="home">
    <PluginHeader
      title="Grid Generator"
      subtitle="Create grids and random points for sampling"
      icon="fas fa-border-none"
    />
    <Alert />
    <Options />
    <GridMap />
    <Menu />
  </div><!-- /#home -->
</template>

<script>
import PluginHeader from '../_shared/PluginHeader.vue'
import Alert from './Alert'
import Options from './Options'
import GridMap from './GridMap'
import Menu from './Menu'
import gridGeneratorModule from './store/module.js'

export default {
  components: {
    PluginHeader,
    Alert,
    Options,
    GridMap,
    Menu
  },
  beforeCreate () {
    // Register the namespaced module fresh on entry so each visit starts
    // from clean state. The module carries the ~1,700-line grid logic
    // (including box sampling) ported verbatim from the legacy plugin.
    if (!this.$store.hasModule || !this.$store.hasModule('gridGenerator')) {
      this.$store.registerModule('gridGenerator', gridGeneratorModule)
    }
  },
  mounted () {
    // Wait for the DOM so GridMap's #gridMap container exists before
    // initGridMap tries to construct the mapbox map on it.
    this.$store.dispatch('gridGenerator/initPlugin')
  },
  beforeDestroy () {
    if (this.$store.hasModule && this.$store.hasModule('gridGenerator')) {
      this.$store.unregisterModule('gridGenerator')
    }
  }
}
</script>
